import { render, staticRenderFns } from "./RelatedPersonInformation.vue?vue&type=template&id=c390fdfc&scoped=true"
import script from "./RelatedPersonInformation.vue?vue&type=script&lang=js"
export * from "./RelatedPersonInformation.vue?vue&type=script&lang=js"
import style0 from "./RelatedPersonInformation.vue?vue&type=style&index=0&id=c390fdfc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c390fdfc",
  null
  
)

export default component.exports